import React from "react";
import bigCardBgImage from "../../../assets/img/nurse.png";
import project from "../../../assets/icons/projects.svg";
import health from "../../../assets/icons/health.svg";
import community from "../../../assets/icons/commnity.svg";
import { Link } from "react-router-dom";

const Impact = () => {
	return (
		<div className='bg-[#F6FEFA]'>
			<div className='max-w-[1440px] w-[90%] mx-auto lg:py-16 py-8'>
				{/* Title */}
				<h2 className='text-3xl md:text-4xl lg:text-5xl text-[#1D1D1D] font-bold lg:mb-12 mb-6'>
					Our Impact So Far
				</h2>
				{/* <img src={bigCardBgImage} alt='' className='h-[50%] w-full' /> */}
				<div
					style={{ backgroundImage: `url(${bigCardBgImage})` }}
					className='h-[648px] w-[90%] mx-auto bg-cover bg-center bg-fixed rounded-[30px]'></div>
				<div className='flex justify-evenly mt-8'>
					<div
						className='text-center bg-cover bg-center bg-no-repeat lg:p-4 p-1 lg:w-40 w-20  rounded-full flex flex-col justify-center items-center tracking-[-2px]'
						style={{ backgroundImage: `url(${project})` }}>
						<p className='font-medium text-2xl/7 lg:text-[72px]/[73px] text-black'>
							10k+
						</p>
						<p className='lg:text-2xl/8 text-xs/3  font-normal text-[#4A4A4A]'>
							Patients
							<br /> Referred
						</p>
					</div>

					<div
						className='text-center bg-cover bg-center bg-no-repeat lg:p-4 p-1 lg:w-40 w-20  rounded-full flex flex-col justify-center items-center tracking-[-2px]'
						style={{ backgroundImage: `url(${health})` }}>
						<p className='font-medium text-2xl/7 lg:text-[72px]/[73px] text-black'>
							50+
						</p>
						<p className='lg:text-2xl/8 text-xs/3  font-normal text-[#4A4A4A]'>
							Healthcare
							<br /> Partners
						</p>
					</div>

					<div
						className='text-center bg-cover bg-center bg-no-repeat lg:p-4 p-1 lg:w-40 w-20  rounded-full flex flex-col justify-center items-center tracking-[-2px]'
						style={{ backgroundImage: `url(${community})` }}>
						<p className='font-medium text-2xl/7 lg:text-[72px]/[73px] text-black'>
							20+
						</p>
						<p className='lg:text-2xl/8 text-xs/3  font-normal text-[#4A4A4A]'>
							Communities <br /> Served
						</p>
					</div>
				</div>

				<div className='flex flex-col lg:flex-row lg:items-start items-center lg:justify-start justify-center mt-20 gap-x-16 gap-y-10'>
					<h1 className='xl:text-[64px]/[76px] text-[40px]/[50px]  font-medium text-[#11112D] max-w-[395px] w-full tracking-[-1px] lg:text-left text-center'>
						Join Our
						<br />
						Community?
					</h1>
					<div className='flex flex-col gap-6 max-w-[680px] lg:w-full sm:w-[80%]'>
						<p className='w-full text-left text-lg text-[#11112d] font-normal'>
							Become Part of the SynergyCare Foundation Patient Community and
							discover a network dedicated to connecting you with the care and
							resources you need, including:
						</p>

						<ul className='w-full text-left text-lg text-[#11112d] font-normal pl-5 space-y-4'>
							<li className='flex items-center gap-2'>
								<i className='fas fa-check text-[#22E27F]'></i>
								Trusted healthcare providers
							</li>
							<li className='flex items-center gap-2'>
								<i className='fas fa-check text-[#22E27F]'></i>
								Support for navigating the healthcare system.
							</li>
							<li className='flex items-center gap-2'>
								<i className='fas fa-check text-[#22E27F]'></i>
								Essential services like transportation and housing support
							</li>
						</ul>

						<Link
							to='/get-started'
							className='text-black lg:text-lg/7 bg-[#22E27F] md:px-[69px] px-10 md:py-4 font-semibold py-2 rounded-full block sm:w-fit w-full text-center lg:mx-0 mx-auto'>
							Get Started
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Impact;
